export default {
      id: "microphone-usage",
      viewBox: "0 0 256 256",
      url: "/dist/svg/" + "sprite.svg#microphone-usage",
      toString: function () {
        return this.url;
      }
    }